import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { providerPrefix } from 'configs/routePrefix';
import StatusModal from "../StatusModal"
import FeedbackModal from "../FeedbackModal"
import LeadService from 'services/Provider/LeadService';

const CardItem = ({ history, item, setShouldGetData }) => {
    const leadService = new LeadService()
    const [modalStatus, setModalStatus] = useState(false)
    const [feedbackModal, setFeedbackModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);

    const handleCloseModal = (action) => {
        setDeleteModal(false);
        if (action === "delete") {
            setShouldGetData(true)
        }
    };
  

    return (
        <>
            <tr key={item.id}>
                <th className="font-size-14 text-center">{item.id}</th>
                <th className="font-size-14 text-center">{item.name}</th>
                <th className="font-size-14 text-center">{item.phone}</th>
                <th className="font-size-14 text-center">{item.open_deals}</th>
                <th className="font-size-14 text-center">{item.last_visited}</th>
                <th className="font-size-14 text-center">{item.nom_searches}</th>
                <th className="font-size-14 text-center">
                    <Badge className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(item.status) }}>{item.status}
                    </Badge>
                </th>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth mb-4 py-0" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => { history.push(`${providerPrefix}/leads/view-lead/${item.id}`) }}>View</DropdownItem>
                            <DropdownItem onClick={() => { history.push(`${providerPrefix}/deals/add-activity/${item.id}/Lead`) }}>Add Activity</DropdownItem>
                            <DropdownItem onClick={setFeedbackModal}>Add Feedback</DropdownItem>
                            <DropdownItem onClick={() => { history.push(`${providerPrefix}/deals/add-deal/${item.id}`) }}>Add Deal</DropdownItem>
                            <DropdownItem onClick={() => { history.push(`${providerPrefix}/appoinments/book-appoinment/add/${item.id}`) }}>Book Appointment</DropdownItem>
                            {/* <DropdownItem onClick={() => { history.push(`${providerPrefix}/create-resale/${item.client_id}`) }}>Add Resale</DropdownItem> */}
                           <hr className="m-0 p-0" />
                            <DropdownItem onClick={() => setModalStatus(!modalStatus)} style={{color:"#212529"}}>Change Status</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={"Appoinment"}
                deletedItem={item}
                modelService={leadService}
                onCloseModal={(action) => handleCloseModal(action)}
            />
            <StatusModal
                modal={modalStatus}
                toggle={() => setModalStatus(!modalStatus)}
                status={item.status}
                id={item.id}
                setShouldGetData={setShouldGetData}
            />
            {feedbackModal ? <FeedbackModal
                modal={feedbackModal}
                id={item.id}
                toggle={() => setFeedbackModal(!feedbackModal)}
                type="list"
                setShouldUpdateDate={() => { }}
            />
                : null}
        </>

    );
}
 
const getBackGround = (status) => {
    return status === "Wrong number" ? "#f1874c"
    : status === "Busy" ? "#f1b44c"
        : status === "Not interested" ? "#50a5f1"
            : status === "Not yet" ? "#74788d"
                : status === "Interested to buy" ? "#931b7f"
                    : status === "Unreachable" ? "#556ee6"
                        : status === "Interested to sell" ? "#54188d"
                            : status === "VIP" ? "#6498ac" 
                            :status==="Deal" ? "#34e38f" :"#95788d"

}
export default CardItem;